import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const SITECONFIG_URL = `${domain}/api/siteconfig`;

export const siteConfigApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSiteConfigDetails: builder.query({
      query: () => ({
        url: `${SITECONFIG_URL}/siteconfig`,
      }),
    }),
  }),
});

export const {
  useGetSiteConfigDetailsQuery,
} = siteConfigApiSlice;
